import React, { useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import CompGroupContext from 'context/CompGroupContext';
import CompGroupsDialog from 'pages/Valuations/components/CompGroups/components/CompGroupsDialog';
import { getInitials } from 'utilities';

interface CompGroupData {
  id?: string | number;
  name: string;
  color: string;
  [key: string]: any;
}

interface CompGroupLabelProps {
  compGroupData: CompGroupData;
  setCompanyInfoHovering?: (isHovering: boolean) => void;
}

const PREFIX = 'CompGroupLabel';

const classes = {
  compGroupLabelInitials: `${PREFIX}-compGroupLabelInitials`,
  compGroupLabel: `${PREFIX}-compGroupLabel`
};

const Root = styled('div')(() => ({
  position: 'relative',
  [`& .${classes.compGroupLabelInitials}`]: (props: CompGroupData) => ({
    border: `solid 1px ${props.color}`,
    color: props.color,
    marginRight: '0.2em',
    fontWeight: 'bold',
    padding: '0 0.1em 0 0.1em',
    cursor: 'pointer',
  }),

  [`& .${classes.compGroupLabel}`]: (props: CompGroupData) => ({
    border: `solid 1px ${props.color}`,
    color: props.color,
    marginRight: '0.2em',
    fontWeight: 'bold',
    padding: '0.2em',
    cursor: 'pointer',
    position: 'absolute',
    top: '-90%',
    backgroundColor: '#FFFFFF',
    borderRadius: '6px',

    '&::after': {
      content: '""',
      position: 'absolute',
      top: '100%',
      left: '10%',
      marginLeft: '-5px',
      borderWidth: '7px',
      borderStyle: 'solid',
      borderColor: `${props.color} transparent transparent transparent`,
    },
  })
}));

const CompGroupLabel: React.FC<CompGroupLabelProps> = ({ compGroupData, setCompanyInfoHovering }) => {
  const [openCompGroupsDialog, setOpenCompGroupsDialog] = useState<boolean>(false);
  const [isHovering, setIsHovering] = useState<boolean>(false);
  const { saveCompGroups, deleteCompGroup, tableData, approachType } = useContext(CompGroupContext);

  const handleClick = (): void => {
    setOpenCompGroupsDialog(true);
    setIsHovering(false);
    if (setCompanyInfoHovering) {
      setCompanyInfoHovering(false);
    }
  };

  const handleOnMouseEnter = (): void => {
    setIsHovering(true);
    if (setCompanyInfoHovering) {
      setCompanyInfoHovering(false);
    }
  };

  const handleOnMouseLeave = (): void => {
    setIsHovering(false);
    if (setCompanyInfoHovering) {
      setCompanyInfoHovering(true);
    }
  };


  const compGroupLabel = compGroupData?.id ? getInitials({ name: compGroupData.name }) : null;

  return (
    <Root onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
      <button type="button" onClick={handleClick} className={classes.compGroupLabelInitials}>
        <span>{compGroupLabel}</span>
      </button>
      {isHovering && (
        <div className={classes.compGroupLabel}>
          <span>{compGroupData.name}</span>
        </div>
      )}
      {openCompGroupsDialog && (
        <CompGroupsDialog
          openCompGroupsDialog
          setOpenCompGroupsDialog={setOpenCompGroupsDialog}
          saveCompGroups={saveCompGroups}
          deleteCompGroup={deleteCompGroup}
          tableData={tableData}
          approachType={approachType}
          defaultCompGroupId={compGroupData.id}
        />
      )}
    </Root>
  );
};

export default CompGroupLabel;